import { useEffect, useRef, useState } from "react";
import Form from "../../../../shared/components/Form";
import Input from "../../../../shared/components/Input";
import Table from "../../../../shared/components/Table";
import EventForm from "../EventForm";

import "./styles.css";
import SideContainer from "../../../../shared/components/SideContainer";
import AttendeeForm from "../AttendeeForm";
import { updateEvent } from "../../../../api/Event";
import { fetchAttendees, updateAttendeeAttendance, updateAttendeeItem } from "../../../../api/Attendee";
import { formatDate } from "../../../../util/date";
import Pill from "../../../../shared/components/Pill";
import { faCalendar, faCalendarCheck, faCalendarTimes, faCertificate, faDownload, faEnvelope, faFileDownload, faIdBadge, faIdCard } from "@fortawesome/free-solid-svg-icons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import CertificateAttendance from "../../../../shared/components/Templates/CertificateAttendance";
import { QRCode } from "react-qrcode-logo";
import IdBadgePDF from "../../../../shared/components/Templates/IdBadge";
import BulkCertificateAttendance from "../../../../shared/components/Templates/BulkCerticateAttendance";
import xlsx from "json-as-xlsx";
import EvaluationResult from "../EvaluationResult";
import { toast } from "react-toastify";
import UploadAttendees from "../UploadAttendees";
import SendEvaluations from "../SendEvaluation";

const getScheduleDates = ({ schedules = "[]" }) => {
  const parsedSchedules = JSON.parse(schedules);
  const dates = parsedSchedules.map(schedule => schedule.date);

  return dates;
};

const getCertSubDetails = ({ schedules = "[]", type }) => {
  let totalHours = 0;

  const parsedSchedules = JSON.parse(schedules);

  parsedSchedules.forEach((schedule) => {
    const [hourIn] = schedule.timeIn.split(":");
    const [hourOut] = schedule.timeOut.split(":");

    const timeDiff = parseInt(hourOut) - parseInt(hourIn);

    totalHours += timeDiff;
  });

  return `for attending the ${totalHours}-hour ${type} entitled`;
};

const getCertDates = ({ schedules = "[]", venue }) => {
  const parsedSchedules = JSON.parse(schedules);

  if (parsedSchedules.length === 0) return "";

  if (parsedSchedules.length === 1)
    return `on ${formatDate(parsedSchedules[0].date)} via ${venue}`;

  const months = ["January","February","March","April","May","June","July",
    "August","September","October","November","December"];

  const [firstYear, firstMonth, firstDay] = parsedSchedules[0].date.split("-");
  const [lastYear, lastMonth, lastDay] = parsedSchedules.at(-1).date.split("-");

  return `on ${months[parseInt(firstMonth) - 1]} ${parseInt(firstDay)}${firstDay !== lastDay ? ` - ${parseInt(lastDay)}` : ``}, ${lastYear} via ${venue}`;
};

const EventItem = ({ item = {}, updateList, setSelectedEvent, preFetchedData }) => {
  const [formActive, setFormActive] = useState(false);
  const [updatedEvent, setUpdatedEvent] = useState(item);
  const [attendeesList, setAttendeesList] = useState([]);
  const [selectedAttendee, setSelectedAttendee] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filterBy, setFilterBy] = useState("");
  const [qrLogoData, setQrLogoData] = useState();
  const [showEvaluation, setShowEvaluation] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  const [activeSendEmail, setActiveSendEmail] = useState(false);

  const qrRef = useRef();

  const retrieveAttendees = async () => {
    const res = await fetchAttendees(item.id);

    if (res.length) {
      setAttendeesList(res.map(item => ({
        ...item,
        payments: JSON.parse(item.payments),
        attendance: JSON.parse(item.attendance),
      })));
    }
  };

  useEffect(() => {
    if (preFetchedData && attendeesList.length) {
      const preFetchAttendee = attendeesList.find(attItem => attItem.id === preFetchedData.id_attendee);

      setSearchQuery(`${preFetchAttendee.personal_name} ${preFetchAttendee.last_name}`);
      setSelectedAttendee(preFetchAttendee);
    }
  }, [preFetchedData, attendeesList])

  useEffect(() => {
    retrieveAttendees();
  }, [item.id]);

  const dates = [];

  const list = [];

  if (item.id) {
    dates.push(...getScheduleDates(updatedEvent));
    console.log("Dates", dates.map(itemD => new Date(itemD)))
    list.push({
      isHeader: true,
      details: [
        {
          content: "Attendee"
        },
        ...dates.map(item => ({
          content: formatDate(item),
          customStyle: {
            whiteSpace: "nowrap"
          }
        })),
      ]
    })
  }

  if (attendeesList.length && list.length) {
    const filteredList = attendeesList
      .filter(attItem => [attItem.personal_name, attItem.last_name].join(" ").toLowerCase().includes(searchQuery.toLowerCase()))
      .filter(attItem => {
        if (!filterBy) return true;

        if (filterBy === "active") {
          console.log("Filtering", attItem);
          return attItem.attendance.some(attendanceItem => attendanceItem.status === "Present");
        }
      })

    filteredList.forEach(filteredItem => {
      const { attendance } = filteredItem;

      list.push({
        ...(filteredItem || {}),
        id: filteredItem.id,
        personal_name: filteredItem.personal_name,
        last_name: filteredItem.last_name,
        refId: filteredItem.reference_id,
        email: filteredItem.email,
        hasSentEvaluation: filteredItem.hasSentEvaluation,
        details: [
          {
            content: `${filteredItem.personal_name} ${filteredItem.last_name}`,
            customStyle: {
              whiteSpace: "nowrap",
            }
          },
          ...dates.map(dateItem => {
            const isPending = attendance.every(attendanceItem => {
              const attendanceDate = new Date(attendanceItem.date);
              const currDate = new Date(dateItem);

              if (attendanceDate.getFullYear() !== currDate.getFullYear()) return true;
              if (attendanceDate.getMonth() !== currDate.getMonth()) return true;
              if (attendanceDate.getDate() !== currDate.getDate()) return true;

              return false;
            });

            const isAbsent = attendance.some(attendanceItem => {
              const attendanceDate = new Date(attendanceItem.date);
              const currDate = new Date(dateItem);

              if (attendanceDate.getFullYear() !== currDate.getFullYear()) return false;
              if (attendanceDate.getMonth() !== currDate.getMonth()) return false;
              if (attendanceDate.getDate() !== currDate.getDate()) return false;

              return attendanceItem.status === "Absent";
            });

            const status = isPending ? "Pending" : isAbsent ? "Absent" : "Present";
            const color = isPending ? "gray" : isAbsent ? "red" : "green";
            const icon = isPending ? faCalendar : isAbsent ? faCalendarTimes : faCalendarCheck;

            return ({
              status: status,
              content: (
                <Pill
                  title={status}
                  color={color}
                  icon={icon}
                  onClick={() => {
                    if (isPending) {
                      setAttendeesList((prev) => {
                        const copy = [...prev];
                        const attendeeIndex = copy.findIndex(copyItem => copyItem.id === filteredItem.id);

                        const updatedAttendee = {
                          ...copy[attendeeIndex],
                          attendance: [
                            ...copy[attendeeIndex].attendance,
                            { date: dateItem, status: "Present" },
                          ],
                        };

                        updateAttendeeAttendance({
                          id: filteredItem.id,
                          attendance: JSON.stringify([
                            ...copy[attendeeIndex].attendance,
                            { date: dateItem, status: "Present" },
                          ]),
                        });

                        copy.splice(attendeeIndex, 1, updatedAttendee);

                        return copy;
                      });
                    } else {
                      setAttendeesList((prev) => {
                        const copy = [...prev];
                        const attendeeIndex = copy.findIndex(copyItem => copyItem.id === filteredItem.id);

                        const currAttendance = [...copy[attendeeIndex].attendance];

                        const attendanceDayIndex = currAttendance.findIndex(currAttendanceItem => {
                          return currAttendanceItem.date === dateItem;
                        });

                        currAttendance.splice(attendanceDayIndex, 1, {
                          date: dateItem,
                          status: isAbsent ? "Present" : "Absent",
                        });

                        updateAttendeeAttendance({
                          id: filteredItem.id,
                          attendance: JSON.stringify(currAttendance),
                        });

                        copy.splice(attendeeIndex, 1, {
                          ...copy[attendeeIndex],
                          attendance: currAttendance,
                        });

                        return copy;
                      });
                    }
                  }}
                />
              ),
              customStyle: {
                whiteSpace: "nowrap",
              }
            })
          })
        ] 
      })
    })
  }

  const handleUpdateItem = (name, value) => {
    setUpdatedEvent({
      ...updatedEvent,
      [name]: value,
    });
  };

  const handleSubmitUpdate = (event) => {
    event.preventDefault();

    const res = updateEvent(updatedEvent);

    if (res) {
      updateList((prev) => {
        const currIndex = prev.findIndex(prevItem => prevItem.id === updatedEvent.id);

        const copyList = [...prev];

        copyList.splice(currIndex, 1, updatedEvent);

        return copyList;
      });

      setFormActive(false);
    }
  }

  const handleSelectedAttendee = (id) => {
    const attendeeItem = attendeesList.find(attItem => attItem.id === id);

    console.log("Attendee Item", attendeeItem);

    setSelectedAttendee(attendeeItem);
  };

  const updateAttendee = (name, value) => {
    setSelectedAttendee({
      ...selectedAttendee,
      [name]: value,
    });
  };

  const submitUpdatedAttendee = async (event) => {
    event.preventDefault();

    const res = await updateAttendeeItem(selectedAttendee);

    if (res) {
      setAttendeesList((prev) => {
        const currIndex = prev.findIndex(prevItem => prevItem.id === selectedAttendee.id);

        const copyList = [...prev];

        copyList.splice(currIndex, 1, selectedAttendee);

        return copyList;
      });

      setSelectedAttendee({});
    }
  }

  const handleAttendeeSearch = (query) => {
    setSearchQuery(query);
  };

  const downloadCertificates = () => {
    const downloadBtn = document.querySelector(".certificates__attendance--link");

    const downloadLink = downloadBtn.querySelector("a");

    downloadLink.click();
  }

  const exportAttendees = () => {
    console.log("List to be exported", list);
    let data = [
      {
        sheet: "Attendance",
        columns: [
          { label: "Attendees", value: "attendee_name" }, // Top level data
          ...list[0].details.slice(1).map((item, index) => ({
            label: item.content,
            value: `attendance_${index}`,
          }))
        ],
        content: list.slice(1).map(itemList => {
          console.log("Item list", itemList)
          const personal = itemList.personal_name.split(" ").map(str => {
            return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
          }).join(" ");

          const last = itemList.last_name.split(" ").map(str => {
            return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
          }).join(" ");

          let attendances = {

          }

          itemList.details.slice(1).map((item, index) => {
            attendances = {
              ...attendances,
              [`attendance_${index}`]: item.status !== "Pending" ? item.status : "",
            };
          })

          return { attendee_name: `${personal} ${last}`, ...attendances };
        }),
      },
      {
        sheet: "Attendees Details",
        columns: [
          { label: "Attendees", value: "attendee_name" }, // Top level data
          { label: "Email", value: "email"},
          { label: "Mobile Number", value: "mobile_number"},
          { label: "Date of Birth", value: "date_of_birth"},
          { label: "Address", value: "address"},
          { label: "Company Name", value: "company"},
          { label: "Position", value: "position"},
          { label: "Company Address", value: "company_address"},
        ],
        content: list.slice(1).map(itemList => {
          console.log("Item list", itemList)
          const personal = itemList.personal_name.split(" ").map(str => {
            return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
          }).join(" ");

          const last = itemList.last_name.split(" ").map(str => {
            return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
          }).join(" ");

          return { attendee_name: `${personal} ${last}`, ...itemList };
        }),
      },
    ]
    
    let settings = {
      fileName: item.name + " - Attendees List", // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    }
    
    xlsx(data, settings) 
    
  };

  console.log("Filtered List", list.slice(1).map(({ email, personal_name, last_name, refId}) => ({
    email,
    personal_name,
    last_name,
    refId,
  })));

  const handleUpload = (data) => {
    setUploadData(data);
  }

  const toggleSendEmail = () => {
    setActiveSendEmail(true);
  }

  return (
    <div className="event__item--wrapper">
      <div className="event__item--details">
        <EventForm
          toggleSendEmail={toggleSendEmail}
          handleUpload={handleUpload}
          defaultValues={updatedEvent}
          title="Event Details"
          activateForm={(value) => setFormActive(value)}
          downloadCertificates={downloadCertificates}
          readOnly={!formActive}
          onChange={handleUpdateItem}
          onSubmit={handleSubmitUpdate}
          onBack={() => setSelectedEvent({})}
          exportAttendees={exportAttendees}
          activeAttendees={list.slice(1).map(({ email, personal_name, last_name, refId, hasSentEvaluation }) => ({
            email,
            personal_name,
            last_name,
            refId,
            hasSentEvaluation,
          }))}
          refetchAttendees={retrieveAttendees}
          toggleEvaluation={() => setShowEvaluation(true)}
        />
      </div>

      <div className="event__item--attendees">
        {!showEvaluation && <Table
          list={list}
          onSelect={handleSelectedAttendee}
          noOfResults={list.length - 1}
          title="Attendance Details"
          onSearch={handleAttendeeSearch}
          defaultSearchValue={searchQuery}
          placeholder="Search by attendee..."
          filter={{
            type: "select",
            options: [{ value: "", label: "All" }, { value: "active", label: "Active" }],
            onChange: (value) => {
              setFilterBy(value);
            },
          }}
        />}

        {showEvaluation && (
          <EvaluationResult eventId={item.id} toggleEvaluation={() => setShowEvaluation(false)} />
        )}
      </div>

      {list.length && (
        <div className="certificates__attendance--link">
          <PDFDownloadLink
          fileName={`${item.name} - Certificates`} document={
            <BulkCertificateAttendance
              title={updatedEvent.name}
              subDetails={getCertSubDetails(updatedEvent)}
              topics={JSON.parse(updatedEvent.topics || "[]")}
              datesDetails={getCertDates(updatedEvent)}
              names={list.slice(1).map(item => {
                const personal = item.personal_name.split(" ").map(str => {
                  return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
                }).join(" ");

                const last = item.last_name.split(" ").map(str => {
                  return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
                }).join(" ");

                return `${personal} ${last}`;
              })}
            />}>
              Download Certificate
          </PDFDownloadLink>
        </div>
      )}

      {!!selectedAttendee?.id && (
        <div class="certificate__attendance--link">
          <PDFDownloadLink
          fileName={`${[selectedAttendee.personal_name, selectedAttendee.last_name].join(" ").replaceAll(".", "")} - Certificate`} document={
            <CertificateAttendance
              name={[selectedAttendee.personal_name, selectedAttendee.last_name].join(" ")}
              title={updatedEvent.name}
              subDetails={getCertSubDetails(updatedEvent)}
              topics={JSON.parse(updatedEvent.topics || "[]")}
              datesDetails={getCertDates(updatedEvent)}
            />}>
              Download Certificate
          </PDFDownloadLink>
        </div>
      )}

      {!!selectedAttendee?.id && (
        <div style={{position: 'absolute', visibility: "hidden", zIndex: -1 }}>
          <QRCode
            value={`https://petros-global.com/ems/submission?refId=${selectedAttendee?.reference_id}`}
            size={250}
            ref={qrRef}
          />
        </div>
      )}

      {!!qrLogoData && !!selectedAttendee?.id && (
        <div className="pdf__downloadable--id-badge" style={{position: 'absolute', visibility: "hidden", zIndex: -1 }}>
          <PDFDownloadLink fileName={`${[selectedAttendee.personal_name, selectedAttendee.last_name].join(" ").replaceAll(".", "")} - ID Badge`} document={
            <IdBadgePDF
              name={[selectedAttendee.personal_name, selectedAttendee.last_name].join(" ")}
              position={selectedAttendee.position}
              company={selectedAttendee.company}
              qrcode={qrLogoData}
            />}>
            Download now
          </PDFDownloadLink>
        </div>
      )}

      {!!selectedAttendee?.id && (
        <SideContainer
          title="Attendee Details" onClose={() => {
            setSelectedAttendee({});
          }}
          configs={[
            {
              icon: faEnvelope,
              tooltip: "Send Evaluation",
              onClick: async () => {
                await fetch(`https://petros-global.com/ems/backend/evaluation/sendMail.php`, {
                  cache: "no-store",
                  headers: {
                    "Authorization": "Ok"
                  },
                  method: "POST",
                  body: JSON.stringify({
                  variables: {
                    eventDetails: {
                        name: updatedEvent.name,
                        type: updatedEvent.type,
                        eventRef: updatedEvent.magic_link,
                    },
                    attendee: {
                      ...selectedAttendee,
                      refId: selectedAttendee.reference_id,
                    },
                    },
                  }),
                });

                toast.success("Successfully sent evaluation!")
              },
            },
            {
              icon: faFileDownload,
              tooltip: "Download Certificate",
              onClick: () => {
                const certificateBtn = document.querySelector(".certificate__attendance--link");
    
                const certificateLink = certificateBtn.querySelector("a");
    
                certificateLink.click();
              },
            },
            {
              icon: faIdBadge,
              tooltip: "Download ID Badge",
              onClick: () => {
                setQrLogoData(qrRef.current?.canvasRef?.current?.toDataURL("image/png", 0.3));

                setTimeout(() => {
                  const certificateBtn = document.querySelector(".pdf__downloadable--id-badge");
    
                  const certificateLink = certificateBtn.querySelector("a");
      
                  certificateLink.click();
                }, 2000);
              },
            },
          ]}
        >
          <AttendeeForm defaultValues={selectedAttendee} onChange={updateAttendee} onSubmit={submitUpdatedAttendee} />
        </SideContainer>
      )}

      {uploadData.length > 0 && (
        <SideContainer className="event__upload--side-container" title="Upload Attendees" onClose={() => {
          setUploadData([]);
          const uploadInput = document.querySelector(".event__upload--input");
          uploadInput.value = "";
        }}>
          <UploadAttendees refreshData={retrieveAttendees} attendees={uploadData} eventId={item.id} />
        </SideContainer>
      )}

      {activeSendEmail && (
        <SideContainer className="event__upload--side-container" title="Send Evaluations" onClose={() => {
          setActiveSendEmail(false);
        }}>
          <SendEvaluations attendees={list.slice(1).map(({ email, personal_name, last_name, refId, hasSentEvaluation }) => ({
              email,
              personal_name,
              last_name,
              refId,
              hasSentEvaluation,
            }))} eventId={item.id} event={updatedEvent} refetchAttendees={retrieveAttendees} />
        </SideContainer>
      )}
    </div>
  )
};

export default EventItem;